import React from "react";
// Images
import bannerImg from "../../../images/banner/banner2.jpg";

const ContactUsBanner = ({ t }) => {
  return (
    <div
      className="page-banner ovbl-dark"
      style={{ backgroundImage: "url(" + bannerImg + ")" }}
    >
      <div className="container">
        <div className="page-banner-entry">
          <h1 className="text-white">{t("contact.us")}</h1>
        </div>
      </div>
    </div>
  );
};

export default ContactUsBanner;
